<app-header></app-header>
<div class="container-fluid main">
    <div class="row">
        <app-messages class="col-md-12"></app-messages>
    </div>
    <router-outlet></router-outlet>
</div>
